export default __webpack_public_path__ + "static/media/GooglePlay.2274714b.png";